const reShopboxKey = /shopbox_uuid/;
const reSvelteAppKey = /svelte-app-v/;

interface ShopboxStorageValue {
    uuid: string;
    [key: string]: any; // Allow other properties
}


const extractUuidFromStorageValue = (value: string) => {
    try {
        const parsedValue: ShopboxStorageValue = JSON.parse(value);
        return parsedValue.uuid ?? '';
    } catch (error) {
        console.warn(`Failed to parse JSON from storage: ${error}`);
        return value;
    }
};

export const getUserId = () => {
  const storedItems = { ...window.localStorage };

  let userId = '';

  for (const [key, value] of Object.entries(storedItems)) {
    if (reShopboxKey.test(key)) {
      userId = extractUuidFromStorageValue(value);
      break;
    }

    if (reSvelteAppKey.test(key)) {
      userId = extractUuidFromStorageValue(value);
    }
  }

  if (!userId) {
    userId = window.crypto.randomUUID();
  }

  return userId;
};
